module.exports = __webpack_public_path__ + "static/media/23-5.3961f341.mp3";